
 
import React, { useEffect } from 'react'
import Event from './eventImg/event-21-march.webp'


const Event35 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on Chilled water Coil Selection & Optimization";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>21 March 2026</h1>
        <h3 className='text-center'>ISHRAE Knowledge Talk on Chilled water Coil Selection & Optimization  </h3>
</div>
   <div className='container' id='calanderevent'>
    <img src={Event} alt='ISHRAE Knowledge Talk on Chilled water Coil Selection & Optimization'/>
     <button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/q4azmdxGHgE=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event35




